
import React from 'react';
import { TableRow, TableCell } from '@/components/ui/table';
import { format, toZonedTime } from 'date-fns-tz';
import { CustomerData } from '@/hooks/admin/types';
import SubscriptionStatusDropdown from '../subscription/SubscriptionStatusDropdown';
import { getPlanOption } from '../subscription/PlanOptions';

interface CustomerTableRowProps {
  customer: CustomerData;
  updateCustomerPlan: (subscriptionId: string, newPlan: string) => Promise<boolean>;
  createCustomerSubscription: (userId: string, plan: string) => Promise<boolean>;
  cancelCustomerSubscription: (userId: string, stripeSubscriptionId: string | null) => Promise<boolean>;
}

const CustomerTableRow: React.FC<CustomerTableRowProps> = ({
  customer,
  updateCustomerPlan,
  createCustomerSubscription,
  cancelCustomerSubscription
}) => {
  // Format date in New Zealand Time
  const formatNZDate = (dateString: string) => {
    // Convert to New Zealand time zone
    const nzTimeZone = 'Pacific/Auckland';
    const date = new Date(dateString);
    const nzDate = toZonedTime(date, nzTimeZone);
    
    // Format as "15 Apr 25, 11:25pm" with capitalized month
    return format(nzDate, "dd MMM yy, h:mma", { timeZone: nzTimeZone });
  };
  
  return (
    <TableRow key={customer.id}>
      <TableCell>{customer.name}</TableCell>
      <TableCell>{customer.email}</TableCell>
      <TableCell>{customer.tracksCount}</TableCell>
      <TableCell>{customer.pageViews}</TableCell>
      <TableCell>{customer.downloads}</TableCell>
      <TableCell>{formatNZDate(customer.created_at)}</TableCell>
      <TableCell>
        <SubscriptionStatusDropdown
          currentPlan={customer.status === 'canceled' ? 'canceled' : (customer.plan || 'pending')}
          customerId={customer.id}
          subscriptionId={customer.subscriptionId}
          stripeSubscriptionId={customer.stripeSubscriptionId}
          onUpdatePlan={updateCustomerPlan}
          onCreateSubscription={createCustomerSubscription}
          onCancelSubscription={cancelCustomerSubscription}
        />
      </TableCell>
    </TableRow>
  );
};

export default CustomerTableRow;
